import MainContainer from '../atoms/container/mainContainer';
import useBackKeyboard from '../../../shared/components/utils/hooks/useBackKeyboard';
import SettingsTitle from '../atoms/text/diskCapacityTitle';
import SettingsInfo from '../atoms/text/diskCapacityInfo';
import PowerSavingContainer from '../atoms/container/powerSavingContainer';
import PowerSavingInfoContainer from '../atoms/container/powerSavingInfoContainer';
import Switcher from '../elements/buttons/switcher';
import PowerSavingSwitcherContainer from '../atoms/container/powerSavingSwitcherContainer';
import Storage from '@storage';
import Focus from '../../../shared/types/enums/focus';
import { useAppSelector } from '../../../shared/store/hooks';
import { focusSelector } from '../../../shared/store/slices/focus.slice';
import useMenu from '../../../shared/components/utils/hooks/useMenu';
import TranslationManager from '../../../shared/assets/locale/translationsManager';

function TPowerSaving() {
  const { focus } = useAppSelector(focusSelector);
  const menuFocused = focus === Focus.MENU;
  useBackKeyboard();
  useMenu(null, true);
  return (
    <MainContainer id={'powerSavingContainer'}>
      <PowerSavingContainer
        animation={menuFocused ? 'main-content-out' : 'main-content-in'}
      >
        <SettingsTitle>
          {TranslationManager.get('PAGES.SETTINGS.POWER_SAVING.PAGE_TITLE')}
        </SettingsTitle>
        <PowerSavingInfoContainer>
          <SettingsInfo
            dangerouslySetInnerHTML={{
              __html: TranslationManager.get(
                'PAGES.SETTINGS.POWER_SAVING.DESCRIPTION'
              ),
            }}
          ></SettingsInfo>
        </PowerSavingInfoContainer>
        <PowerSavingSwitcherContainer>
          <Switcher
            active={
              Storage.get('deadmanActive') === '1' ||
              !Storage.get('deadmanActive')
            }
          ></Switcher>
        </PowerSavingSwitcherContainer>
      </PowerSavingContainer>
    </MainContainer>
  );
}

export default TPowerSaving;
